/* eslint-disable no-lone-blocks */
/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import {
  isWeekend
  // TimeStampIntoHours
} from "../../../constant/helper/helper";
import { SHIFT_COLOR } from "../../../constant/constant";

import isEmpty from "../../../validation/isEmpty";

const DateList = ({ dayList }) => {
  return dayList.map((dateValue, dateIndex) => {
    const weekendOrNot = isWeekend(dateValue.date);
    return (
      <td
        key={dateIndex}
        className={
          weekendOrNot
            ? "table-action text-center bg-danger-lighten"
            : "table-action text-center"
        }
      >
        <span
          className={
            !isEmpty(dateValue.shiftCode)
              ? SHIFT_COLOR[dateValue.shiftCode.trim()]
              : ""
          }
        >
          {!isEmpty(dateValue.shiftCode) ? dateValue.shiftCode : "-"}
        </span>
      </td>
    );
  });
};

DateList.propTypes = {
  dayList: PropTypes.array.isRequired
};

export default DateList;
